/* eslint-disable react/no-array-index-key */

import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as Link } from 'react-router-dom'
import styles from './NavLinks.scss'
import { hasAccess } from 'utils/hasAccess'
import { clearAdminSessions } from 'utils/clearSession'

const NavLink = ({ link }) => {
  const isActive = (match, location) => {
    if (location.pathname.indexOf('detailedreport') > -1 && link.to.indexOf('reports') > -1) { return true }
    if (location.pathname.indexOf('partnerplan/plan') > -1 && link.to.indexOf('partnerplans') > -1) { return true }
    if (!match) { return false }
    if (match.isExact) { return true }
    // return location.pathname.startsWith(match.path) && match.path.length > 1
    return location.pathname.startsWith(link.to) && (link.to !== '/')
  }

  if (link.to.startsWith('http')) {
    return <a className={styles.navLink} href={link.to} target="_blank">{link.label}</a>
  }
  return <Link activeClassName={styles.isActive} className={styles.navLink} isActive={isActive} to={link.to}>{link.label}</Link>
}

NavLink.propTypes = {
  link: PropTypes.object.isRequired,
}

const NavLinks = ({ showAdminLinks, currentUser, history }) => {
  const navLinksPartner = [{
    label: 'Home',
    to: '/',
  }, {
    label: 'Personal Info',
    to: '/personalinfo',
  }, {
    label: 'Beneficiaries',
    to: '/beneficiaries',
  }, {
    label: 'Accounts & Loans',
    to: '/accountsandloans',
  }, {
    label: 'Documents',
    to: '/documents',
  }, {
    label: 'Plan',
    to: '/partnerplans',
  }, {
    label: 'Reports',
    to: '/reports',
  }]

  const navLinksAdmin = [{
    label: 'Admin centre',
    to: '/admin/admincentre',
    permission: 'ADMN: Search For Partner',
  }, {
    label: 'Reports',
    to: '/admin/reports',
    permission: 'ADMN: Reports',
  }]

  clearAdminSessions(currentUser)

  return (
    <div className={styles.navLinks}>
      {!showAdminLinks && navLinksPartner.map((link, key) => <NavLink key={key} link={link} />)}
      {showAdminLinks && navLinksAdmin.map(item =>
        hasAccess(currentUser, item.permission, history, 'R', false) && <NavLink key={item.label} link={item} />)}
    </div>
  )
}

NavLinks.propTypes = {
  currentUser: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  showAdminLinks: PropTypes.bool.isRequired,
}

export default NavLinks



// WEBPACK FOOTER //
// ./src/components/Header/NavLinks.js